import { TDictionary, TPaymentOrder } from '@shared/types';
import { getLsConfig } from '@shared/legacy_compat/nextjs/lsconfig/getLsConfig';
import _ from 'lodash';
// @ts-ignore
import Tap from '@tapfiliate/tapfiliate-js';

const debug_log = false;

export const getTapfiliateId = (): string => {
  const { runtimeConfig } = getLsConfig();
  return runtimeConfig?.NEXT_PUBLIC_TAPFILIATE_ID;
};

export const tapfiliateInit = async () => {
  const tapfiliateId = getTapfiliateId();
  if (!_.isNil(tapfiliateId)) {
    if (debug_log) {
      console.log(`Init tapfiliate (${tapfiliateId})...`);
    }
    Tap.init(tapfiliateId);
  }
};

type TCommission = {
  commission_type: string;
  sub_amount: number;
};
type TCommissionData = {
  tax_value: number;
  total_price: number;
};

export const tapfiliateConversion = async (paymentOrder: TPaymentOrder) => {
  const tapfiliateId = getTapfiliateId();
  const without_tax = true;

  if (!_.isNil(tapfiliateId)) {
    const orderNumber = _.get(paymentOrder, 'DATA.orderNumber', null);
    const amount = _.get(paymentOrder, 'DATA.amount.value', null);
    if (debug_log) {
      console.log(
        `Generate conversions for ${orderNumber} (${amount} €) using tapfiliate id: ${tapfiliateId} ...`,
      );
    }

    console.log('tapfiliateConversion:', paymentOrder);
    const conversion_entries: [string, TCommissionData][] = Object.entries(
      _.get(paymentOrder, 'DATA.metadata.conversions', {}),
    );

    if (conversion_entries.length !== 0) {
      const conversions = conversion_entries.map(
        ([commission_type, commission_data]: [
          string,
          TCommissionData,
        ]): TCommission => {
          const sub_amount = without_tax
            ? commission_data.total_price - commission_data.tax_value
            : commission_data.total_price;
          return { commission_type, sub_amount };
        },
      );
      const options = {
        coupons: _.get(paymentOrder, 'DATA.metadata.coupons', []),
        customer_id: _.get(paymentOrder, 'DATA.metadata.CUSTOMER_ID', null),
      };
      if (debug_log) {
        console.log('Send data to tapfiliate:');
        //     console.log(`Options: ${JSON.stringify(options, null, 2)}`);
        console.log(`Options: ${JSON.stringify(options, null, 2)}`);
        console.log(`Comissions: ${JSON.stringify(conversions, null, 2)}`);
      }
      //
      // Tapfiliate conversion call
      Tap.conversionMulti(orderNumber, options, conversions);
    }
  }
};
